import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LightModeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"light_mode"}/>
}
